const meta = {
    logo: "../images/logos/ailleratech_080.png",
    title: "AIllera Technologies",
    description: "AIllera Technologies is a Computer Programming Activities Company",
};

const languages = [
    { 
        img: "/images/flags/eng_128.png", 
        name: "English",
        name_eng: "English",
        name_esp: "Inglés",
        name_cat: "Anglès"
    },
    { 
        img: "/images/flags/esp_128.png", 
        name: "Spanish",
        name_eng: "Spanish",
        name_esp: "Español",
        name_cat: "Espanyol"
    },
    { 
        img: "/images/flags/cat_128.png", 
        name: "Catalan",
        name_eng: "Catalan",
        name_esp: "Catalán",
        name_cat: "Català"
    },
];

const menu_options = {
    home_eng: "Home",
    home_esp: "Inicio",
    home_cat: "Inici",

    b2b_eng: "Services to Companies",
    b2b_esp: "Servicios para Empresas",
    b2b_cat: "Serveis a empreses",

    b2c_eng: "Products for consumers",
    b2c_esp: "Producto al consumidor",
    b2c_cat: "Producte al consumidor",

    about_eng: "About",
    about_esp: "Sobre mí",
    about_cat: "Sobre mi",

    contact_eng: "Contact",
    contact_esp: "Contacto",
    contact_cat: "Contacte",
}

const section_home = {
    title: "AIllera Technologies SLU",

    animated_eng: {
        first: "Data Science Services",
        second: "Complex Modelling Services",
        third: "Aerodynamic Analysis",
        fourth: "Promotion of STEM subjects (Science, Technology, Engineering and Mathematics)",
        fifth: "Computer Programming Activities",
    },

    animated_esp: {
        first: "Servicios de Ciencia de Datos",
        second: "Servicios de Modelado Complejo",
        third: "Análisis Aerodinámico",
        fourth: "Promoción de las disciplinas STEM (Ciencia, Tecnología, Ingeniería y Matemáticas)",
        fifth: "Actividades de Programación Informática",
    },

    animated_cat: {
        first: "Serveis de Ciència de Dades",
        second: "Serveis de Modelatge Complex",
        third: "Anàlisi Aerodinàmica",
        fourth: "Promoció de les disciplines STEM (Ciència, Tecnologia, Enginyeria i Matemàtiques)",
        fifth: "Activitats de Programació Informàtica",
    },

    description_eng: "At AIllera Technologies, we create advanced numerical models and data-driven simulations that capture reality with the highest possible accuracy. Our expertise combines aerodynamics, computational fluid dynamics (CFD), and data science with cutting-edge methods in high-performance computing and artificial intelligence.\n\nWe believe that the future of engineering lies in the fusion of physics-based models and AI, enabling organizations to design, test, and innovate faster—without compromising on precision.",
    description_esp: "En AIllera Technologies creamos modelos numéricos avanzados y simulaciones basadas en datos que capturan la realidad con la máxima precisión posible. Nuestra experiencia combina aerodinámica, dinámica de fluidos computacional (CFD) y ciencia de datos con métodos de vanguardia en computación de alto rendimiento e inteligencia artificial.\n\nCreemos que el futuro de la ingeniería reside en la fusión de los modelos basados en la física con la IA, lo que permite a las organizaciones diseñar, probar e innovar más rápido, sin comprometer la precisión.",
    description_cat: "A AIllera Technologies creem models numèrics avançats i simulacions basades en dades que capturen la realitat amb la màxima precisió possible. La nostra experiència combina aerodinàmica, dinàmica de fluids computacional (CFD) i ciència de dades amb mètodes d'avantguarda en computació d'alt rendiment i intel·ligència artificial.\n\nCreiem que el futur de l'enginyeria rau en la fusió dels models basats en la física amb la IA, permetent a les organitzacions dissenyar, provar i innovar més ràpid sense comprometre la precisió.",

    button1_eng: "Servicies",
    button1_esp: "Servicios",
    button1_cat: "Serveis",

    button2_eng: "Products",
    button2_esp: "Productos",
    button2_cat: "Productes",

    backgroundImagePath: "/images/home_background.png",
};

const section_about = {
    main_eng: "About the founder",
    main_esp: "Sobre el fundador",
    main_cat: "Sobre el fundador",

    // PART 1
    title1_eng: "Background",
    title1_esp: "Trayectoria",
    title1_cat: "Trajectòria",

    content1_eng: "My name is Albert Illera and I am the founder of AIllera Technologies SLU. In order to explain my background, please allow me to go a bit personal — something that I proactively avoid in the rest of this website. I have had the privilege of working in my dream jobs for over 14 years. Back in the 90s, I was a tiny kid absolutely fascinated by the world around me. I vividly remember watching Formula 1 races and wondering how those incredible machines worked. That curiosity shaped my entire life — leading me to study engineering, specialize in aerodynamics, and eventually work in several Formula 1 teams. Today, I apply that same passion for precision and data-driven understanding to create simulations and AI systems that bring history, science, and technology to life. This company is currently just an experimental setup, aiming to use lean startup methodologies to experiment on the many ideas I had not been able while working in Formula 1, but the objective is to expand quickly if these projects gather traction! Stay tuned for releases on the B2C side or if you are a company, feel free to contact us if you need an F1 approach deployed in your company.",
    content1_esp: "Me llamo Albert Illera y soy el fundador de AIllera Technologies SLU. Para explicar mi trayectoria, permíteme ser un poco personal — algo que evito de forma proactiva en el resto de esta web. He tenido el privilegio de trabajar en mis empleos soñados durante más de 14 años. En los años 90 era un niño pequeño absolutamente fascinado por el mundo que le rodeaba. Recuerdo vívidamente ver las carreras de Fórmula 1 y preguntarme cómo funcionaban aquellas máquinas increíbles. Esa curiosidad marcó toda mi vida: me llevó a estudiar ingeniería, especializarme en aerodinámica y trabajar en varios equipos de Fórmula 1. Hoy aplico esa misma pasión por la precisión y la comprensión basada en datos para crear simulaciones y sistemas de inteligencia artificial que dan vida a la historia, la ciencia y la tecnología.",
    content1_cat: "El meu nom és ALbert Illera i soc el fundador d’AIllera Technologies SLU. Per explicar la meva trajectòria, permet-me ser una mica personal — cosa que evito de manera proactiva a la resta d’aquesta web. He tingut el privilegi de treballar als meus llocs de somni durant més de 14 anys. Als anys 90 era un nen petit absolutament fascinat pel món que l’envoltava. Recordo perfectament veure les curses de Fórmula 1 i preguntar-me com funcionaven aquelles màquines increïbles. Aquella curiositat va marcar tota la meva vida: em va portar a estudiar enginyeria, a especialitzar-me en aerodinàmica i a treballar en diversos equips de Fórmula 1. Avui aplico aquesta mateixa passió per la precisió i la comprensió basada en dades per crear simulacions i sistemes d’intel·ligència artificial que donen vida a la història, la ciència i la tecnologia.",

    // PART 2
    title2_eng: "Work Timeline",
    title2_esp: "Experiencia profesional",
    title2_cat: "Experiència professional",

    // Table headers
    th_employer_eng: "Employer",
    th_employer_esp: "Empleador",
    th_employer_cat: "Empresa",

    th_role_eng: "Role",
    th_role_esp: "Cargo",
    th_role_cat: "Càrrec",

    th_location_eng: "Location",
    th_location_esp: "Ubicación",
    th_location_cat: "Ubicació",

    th_date_eng: "Date",
    th_date_esp: "Fecha",
    th_date_cat: "Data",
};

const section_work = [
    {
        img: './images/logos/renault_128.png',
        employer: "Renault F1 Team",
        jobtitle_eng: "Powertrain CFD Engineer",
        jobtitle_esp: "Ingeniero CFD de la unidad de potencia",
        jobtitle_cat: "Enginyer CFD de la unitat de potència",
        where_eng: "Viry-Châtillon, France",
        where_esp: "Viry-Châtillon, Francia",
        where_cat: "Viry-Châtillon, França",
        date_eng: "September 2020 – April 2021",
        date_esp: "Septiembre 2020 – Abril 2021",
        date_cat: "Setembre 2020 – Abril 2021",
    },
    {
        img: './images/logos/mclaren_128.png',
        employer: "McLaren F1 Team",
        jobtitle_eng: "Aerodynamicist / Correlation Aerodynamicist",
        jobtitle_esp: "Aerodinamicista / Aerodinamicista de correlación",
        jobtitle_cat: "Aerodinamicista / Aerodinamicista de correlació",
        where_eng: "Woking, United Kingdom",
        where_esp: "Woking, Reino Unido",
        where_cat: "Woking, Regne Unit",
        date_eng: "April 2021 – November 2022",
        date_esp: "Abril 2021 – Noviembre 2022",
        date_cat: "Abril 2021 – Novembre 2022",
    },
    {
        img: './images/logos/williams_128.png',
        employer: "Williams Grand Prix Engineering",
        jobtitle_eng: "Senior CFD Engineer / Lead Data Scientist",
        jobtitle_esp: "Ingeniero sénior de CFD / Científico de datos principal",
        jobtitle_cat: "Enginyer sènior de CFD / Científic de dades principal",
        where_eng: "Grove, United Kingdom",
        where_esp: "Grove, Reino Unido",
        where_cat: "Grove, Regne Unit",
        date_eng: "November 2022 – February 2024",
        date_esp: "Noviembre 2022 – Febrero 2024",
        date_cat: "Novembre 2022 – Febrer 2024",
    },
    {
        img: './images/logos/cadillac_128.png',
        employer: "Cadillac F1 Team",
        jobtitle_eng: "Senior Correlation Engineer",
        jobtitle_esp: "Ingeniero sénior de correlación",
        jobtitle_cat: "Enginyer sènior de correlació",
        where_eng: "Silverstone, United Kingdom",
        where_esp: "Silverstone, Reino Unido",
        where_cat: "Silverstone, Regne Unit",
        date_eng: "July 2024 - February 2025",
        date_esp: "Julio 2024 - Febrero 2025",
        date_cat: "Juliol 2024 - Febrer 2025",
    },
];

const section_b2b = [
    {
        image: './images/projects/data_science.png',
        title_eng: "Data Science",
        title_esp: "Ciencia de Datos",
        title_cat: "Ciència de Dades",
        description_eng: "We transform complex datasets into actionable insights using advanced analytics, statistical modeling, and AI-assisted interpretation. From historical research to predictive simulations, we build robust systems that turn raw data into strategic understanding.",
        description_esp: "Transformamos conjuntos de datos complejos en información procesable utilizando análisis avanzados, modelos estadísticos e interpretación asistida por IA. Desde la investigación histórica hasta las simulaciones predictivas, construimos sistemas robustos que convierten los datos brutos en comprensión estratégica.",
        description_cat: "Transformem conjunts de dades complexos en coneixement accionable utilitzant analítica avançada, models estadístics i interpretació assistida per IA. Des de la investigació històrica fins a les simulacions predictives, construïm sistemes robustos que converteixen les dades brutes en comprensió estratègica.",
    },
    {
        image: './images/projects/aerodynamics_cfd.png',
        title_eng: "Aerodynamics - Computational Fluid Dynamics",
        title_esp: "Aerodinámica - Dinámica de Fluidos Computacional (CFD)",
        title_cat: "Aerodinàmica - Dinàmica de Fluids Computacional (CFD)",
        description_eng: "Our background in Formula 1 engineering allows us to deliver precise CFD simulations for both industrial and educational purposes. We combine physical accuracy with visualization and performance optimization to analyze and communicate aerodynamic phenomena effectively.",
        description_esp: "Nuestra experiencia en ingeniería de Fórmula 1 nos permite ofrecer simulaciones CFD precisas tanto para fines industriales como educativos. Combinamos precisión física con visualización y optimización del rendimiento para analizar y comunicar fenómenos aerodinámicos de forma efectiva.",
        description_cat: "La nostra experiència en enginyeria de Fórmula 1 ens permet oferir simulacions CFD precises tant per a finalitats industrials com educatives. Combinem precisió física amb visualització i optimització del rendiment per analitzar i comunicar fenòmens aerodinàmics de manera efectiva.",
    },
    {
        image: './images/projects/ai_automation.png',
        title_eng: "AI Automation",
        title_esp: "Automatización con IA",
        title_cat: "Automatització amb IA",
        description_eng: "We design intelligent pipelines that automate research, data extraction, and simulation processes. Using state-of-the-art AI and RAG (Retrieval-Augmented Generation) systems, we ensure efficient workflows and trustworthy, source-backed results tailored to each project’s needs.",
        description_esp: "Diseñamos flujos de trabajo inteligentes que automatizan la investigación, la extracción de datos y los procesos de simulación. Mediante el uso de IA de vanguardia y sistemas RAG (Generación Aumentada por Recuperación), garantizamos flujos de trabajo eficientes y resultados fiables con respaldo de fuentes, adaptados a las necesidades de cada proyecto.",
        description_cat: "Dissenyem pipelines intel·ligents que automatitzen la investigació, l'extracció de dades i els processos de simulació. Utilitzant IA d'última generació i sistemes RAG (Generació Augmentada per Recuperació), garantim fluxos de treball eficients i resultats fiables amb el suport de fonts, adaptats a les necessitats de cada projecte.",
    },
    {
        image: './images/projects/stem.png',
        title_eng: "Promotion of STEM Subjects",
        title_esp: "Promoción de Asignaturas STEM",
        title_cat: "Promoció d'Assignatures STEM",
        description_eng: "We create engaging digital experiences that spark curiosity in Science, Technology, Engineering, and Mathematics. Through accurate simulations, interactive content, and data-driven storytelling, we help institutions and audiences connect with STEM in a meaningful, accessible way.",
        description_esp: "Creamos experiencias digitales atractivas que despiertan la curiosidad por la Ciencia, la Tecnología, la Ingeniería y las Matemáticas. A través de simulaciones precisas, contenido interactivo y narración basada en datos, ayudamos a instituciones y audiencias a conectar con STEM de una manera significativa y accesible.",
        description_cat: "Creem experiències digitals atractives que desperten la curiositat per la Ciència, la Tecnologia, l'Enginyeria i les Matemàtiques. A través de simulacions precises, contingut interactiu i narració basada en dades, ajudem institucions i audiències a connectar amb STEM d'una manera significativa i accessible.",
    },
];

const section_b2c = [
    {
        image: './images/projects/spanish_civil_war.png',
        title_eng: "PRODUCT 1 (Spanish Civil War)",
        title_esp: "PRODUCTO 1 (Guerra Civil Española)",
        title_cat: "PRODUCTE 1 (Guerra Civil Espanyola)",
        description_eng: "As the years 2026-2029 approach, the 90th anniversary of many of the dates that shook a generation and the entire history of Spain will take place. Facilitating the understanding of such a complex event using simulations is a task we want to fulfil over the next few years.",
        description_esp: "A medida que se acercan los años **2026-2029**, tendrá lugar el **90º aniversario** de muchas de las fechas que sacudieron a una generación y a toda la historia de España. Facilitar la comprensión de un evento tan complejo mediante simulaciones es una tarea que queremos cumplir durante los próximos años.",
        description_cat: "A mesura que s'acosten els anys **2026-2029**, tindrà lloc el **90è aniversari** de moltes de les dates que van sacsejar una generació i tota la història d'Espanya. Facilitar la comprensió d'un esdeveniment tan complex mitjançant simulacions és una tasca que volem complir durant els pròxims anys."  },
    {
        image: './images/projects/housing.png',
        title_eng: "PRODUCT 2 (Housing Policy)",
        title_esp: "PRODUCTO 2 (Política de Vivienda)",
        title_cat: "PRODUCTE 2 (Política d'Habitatge)",
        description_eng: "In Spain, as in a large part of the world's nations, housing has become one of the most pressing social issues. The increase in both sale and rental prices is a response to a complex system of incentives, feedback loops, and political decisions, the modeling of which may be of interest to the general public.",
        description_esp: "Tanto en España como en gran parte de las naciones del mundo, la vivienda se ha convertido en una de las **problemáticas sociales** más **apremiantes**. El aumento de los precios tanto de venta como de alquiler responde a un complejo sistema de incentivos, *feedback loops* y decisiones **políticas** cuyo modelado puede resultar de interés para el **público** general.",
        description_cat: "Tant a Espanya com a gran part de les nacions del món, l'habitatge s'ha convertit en una de les **problemàtiques socials** més **apremiants**. L'augment dels preus tant de venda com de lloguer respon a un complex sistema d'incentius, *feedback loops* i decisions **polítiques** el modelatge del qual pot resultar d'interès per al **públic** general."
    }
];

const section_contact = {
    title_eng: "Contact Me",
    title_esp: "Contáctame",
    title_cat: "Contacta’m",
    
    get_in_touch_eng: "Get in touch",
    get_in_touch_esp: "Ponte en contacto",
    get_in_touch_cat: "Posa't en contacte",

    // Placeholders
    placeholder_name_eng: "Name",
    placeholder_name_esp: "Nombre",
    placeholder_name_cat: "Nom",

    placeholder_email_eng: "Email",
    placeholder_email_esp: "Correo electrónico",
    placeholder_email_cat: "Correu electrònic",

    placeholder_message_eng: "Message",
    placeholder_message_esp: "Mensaje",
    placeholder_message_cat: "Missatge",

    send_eng: "Send",
    send_esp: "Enviar",
    send_cat: "Enviar",

    sending_eng: "Sending...",
    sending_esp: "Enviando...",
    sending_cat: "Enviant...",

    // Contact Details
    YOUR_EMAIL: "contact@aillera.com",
    label_email_eng: "Email:",
    label_email_esp: "Correo electrónico:",
    label_email_cat: "Correu electrònic:",

    // Explanation
    description_eng: "Please, tell us briefly what your request is about. We aim to reply in two working days. ",
    description_esp: "Por favor, indíquenos brevemente sobre qué trata su solicitud. Nuestro objetivo es responder en dos días laborables. ",
    description_cat: "Si us plau, indiqueu-nos breument sobre què tracta la vostra sol·licitud. El nostre objectiu és respondre en dos dies laborables. ",

    // Alerts
    message_success_eng: "SUCCESS! Thank you for your message",
    message_success_esp: "¡ÉXITO! Gracias por tu mensaje",
    message_success_cat: "ÈXIT! Gràcies pel teu missatge",

    message_error_eng: "Failed to send! Please try again later.",
    message_error_esp: "¡Error al enviar! Por favor, inténtalo más tarde.",
    message_error_cat: "Error en enviar! Torna-ho a provar més tard.",
    
    // Use environment variables if available, otherwise fall back to defaults
    // In production, set these in your .env file
    YOUR_SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_id",
    YOUR_TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_id",
    YOUR_USER_ID: process.env.REACT_APP_EMAILJS_USER_ID || "user_id",
};

const socialprofils = {
    linkedin: "https://linkedin.com/company/aillera-technologies",
};

export {
    meta,
    menu_options,
    socialprofils,
    languages,
    // SECTIONS
    section_home,
    section_about,
    section_work,
    section_b2b,
    section_b2c,
    section_contact,
};